import { provideHttpClient } from "@angular/common/http";
import { ApplicationConfig, ErrorHandler, importProvidersFrom } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withRouterConfig } from "@angular/router";
import { biTranslateProviders } from "@globals/bi-translate/bi-translate-providers";
import { SharedRouteNames } from "@globals/classes/SharedRouteNames";
import { BiErrorHandlerService } from "@globals/services/bi-error-handler.service";
import { APPLICATION_NAME } from "@globals/services/injection-tokens/application-name-token";
import { BI_ENVIRONMENT } from "@globals/services/injection-tokens/environment-token";
import { ToastrModule } from "ngx-toastr";
import { ConfirmationService } from "primeng/api";
import { providePrimeNG } from "primeng/config";
import { IframeModulesPrimeNgThemePreset } from "../iframe-modules-primeNg-theme-preset";
import { environment } from "src/environments/environment";
function getPathName() {
  // Remove the leading and ending "/" if present before comparing to route name values.
  let pathName = window.location.pathname;
  if (pathName.startsWith("/")) pathName = pathName.substring(1);
  if (pathName.endsWith("/")) pathName = pathName.substring(0, pathName.length - 1);
  return pathName;
}

function loadComponentFunc() {
  // Load component based on current URL's path name
  const pathName = getPathName().toLowerCase();
  switch (pathName) {
    case SharedRouteNames.iFrameRoutes.driftstatus.toLowerCase():
      return import("./driftstatus/iframe-driftstatus.component");
    case SharedRouteNames.iFrameRoutes.driftstatusMap.toLowerCase():
      return import("./driftstatus-map/iframe-driftstatus-map.component");
  }
}

function loadModuleFunc() {
  const pathName = getPathName().toLowerCase();
  if (pathName === SharedRouteNames.iFrameRoutes.subscription.toLowerCase()) return import("./subscribe-unsubscribe/subscription-module-normal/iframe-subscription.module");
  if (pathName === SharedRouteNames.iFrameRoutes.stdReceivers.toLowerCase()) return import("./subscribe-unsubscribe/subscription-module-std-receivers/iframe-subscription-std-receiver.module");
}
/**
 * Determines whether the current url will need to load an Angular Module or not
 */
function isModule() {
  const pathName = getPathName().toLowerCase();
  return (
    pathName.indexOf(SharedRouteNames.iFrameRoutes.subscription.toLowerCase()) !== -1 || pathName.indexOf(SharedRouteNames.iFrameRoutes.stdReceivers.toLowerCase()) !== -1 //||
  );
}

const routes = [
  { path: SharedRouteNames.unavailable, loadComponent: () => import("@globals/components/unavailable/unavailable.component") },
  { path: "", loadComponent: () => loadComponentFunc(), canMatch: [() => !isModule()] },
  { path: "", loadChildren: () => loadModuleFunc() }
];

export const iframeModulesAppConfig: ApplicationConfig = {
  providers: [
    { provide: BI_ENVIRONMENT, useValue: environment },
    { provide: APPLICATION_NAME, useValue: "Iframe Modules App" },
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: "reload",
        paramsInheritanceStrategy: "always"
      }),
      withInMemoryScrolling({ scrollPositionRestoration: "top" }),
      withComponentInputBinding()
    ),
    ...biTranslateProviders,
    provideHttpClient(),
    providePrimeNG({
      theme: {
        preset: IframeModulesPrimeNgThemePreset,
        options: {
          darkModeSelector: false || "none" // disables dark mode selector
        }
      }
    }),
        importProvidersFrom(ToastrModule.forRoot({ timeOut: 10000, closeButton: true }), BrowserAnimationsModule, BrowserModule),
        ConfirmationService,
        { provide: ErrorHandler, useClass: BiErrorHandlerService }
  ]
};
